import React from 'react';
import { FormattedMessage } from 'react-intl';

import Modal, { ModalProps } from 'components/ui/Modal';

import CourtesyVehicle from '.';

const CourtesyVehicleModal: React.FC<Pick<ModalProps, 'open' | 'onClose'>> = ({ open, onClose }) => (
  <Modal
    open={open}
    onClose={onClose}
    className="modal-large max-h-[85vh] flex flex-col"
    title={<FormattedMessage id="courtesyVehicle.title" defaultMessage="Courtesy vehicle" tagName="h1" />}
  >
    <div className="flex flex-col gap-5 overflow-y-auto p-8">
      <CourtesyVehicle />
    </div>
  </Modal>
);

export default CourtesyVehicleModal;
